<template>
  <AppWrapper>
    <NuxtLayout>
      <NuxtPage keepalive />
    </NuxtLayout>
  </AppWrapper>
</template>
